/**
 * Chart.js 2 pie legend labels with macronutrient share (%).
 */
export const buildMacronutrientPieOptions = (baseOptions = {}, legendProp = {}) => {
  const baseLegend = baseOptions.legend || {};

  return {
    ...baseOptions,
    legend: {
      ...baseLegend,
      display: legendProp.display !== undefined ? legendProp.display : baseLegend.display !== false,
      position: legendProp.position || baseLegend.position || 'right',
      labels: {
        ...baseLegend.labels,
        generateLabels(chart) {
          const chartData = chart.data;
          const dataset = chartData.datasets && chartData.datasets[0];

          if (!dataset || !chartData.labels) {
            return [];
          }

          const meta = chart.getDatasetMeta(0);
          const values = (dataset.data || []).map((value) => Number(value) || 0);
          const sum = values.reduce((total, value) => total + value, 0);

          return chartData.labels.map((label, index) => {
            const percent = sum > 0 ? ((values[index] / sum) * 100).toFixed(1) : '0.0';

            return {
              text: `${label} (${percent}%)`,
              fillStyle: dataset.backgroundColor[index],
              strokeStyle: dataset.backgroundColor[index],
              lineWidth: 0,
              hidden: meta.data[index] ? meta.data[index].hidden : false,
              index,
            };
          });
        },
      },
    },
  };
};
